<template lang="html">
<div class="section">
  <!-- Request access code -->
  <div class="container has-text-centered"
       v-if="step % 2 == 0">

    <b-field label="Email"
             horizontal>
      <!-- Must provide key to prevent input element being reused. -->
      <b-input required
               key="email"
               v-model="email"
               type="email">
      </b-input>
    </b-field>

    <b-field grouped
             position="is-centered">
      <p class="control">
        <b-button
          class="is-light"
          :loading="loading"
          v-on:click="requestCode">
          Request access code
        </b-button>
      </p>
    </b-field>

    <b-field v-if="step >= 2"
             grouped
             position="is-centered">
      <p class="control">
        <b-button
          class="is-light"
          v-on:click="nextStep()">
          Already have code?
        </b-button>
      </p>
    </b-field>
  </div>

  <!-- Enter access code -->
  <div class="container has-text-centered"
       v-if="step % 2 == 1">

    <p>Enter access code for email: {{ email }}</p>

    <b-field label="Code"
             horizontal>
      <!-- Must provide key to prevent input element being reused. -->
      <b-input required
               key="access-code"
               v-model="accessCode"
               type="text"
               placeholder="123456"
               minlength="6"
               maxlength="6"
               inputmode="numeric"
               pattern="[0-9]*"
               validation-message="Only numbers are allowed.">
      </b-input>
    </b-field>

    <div class="level is-mobile">
      <b-field class="level-item">
        <p class="control">
          <b-button
            class="is-light"
            v-on:click="nextStep()">
            Back
          </b-button>
        </p>
      </b-field>
      <b-field class="level-item">
        <p class="control">
          <b-button
            class="is-light"
            :loading="loading"
            v-on:click="login">
            Login
          </b-button>
        </p>
      </b-field>
    </div>

    <p>
      Access codes expire after 15 minutes. Check your junk folder!
    </p>
  </div>

  <div v-if="errorMsg !== ''">
    <p>Sorry cannot sign in at the moment!</p>
    <p>{{ errorMsg }}</p>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex'
import {
  AUTH_CODE_REQUEST,
  AUTH_LOGIN_REQUEST
} from '@/store/actions/auth'

export default {
  data () {
    return {
      email: null,
      accessCode: null,
      errorMsg: '',
      step: 0
    }
  },
  computed: {
    ...mapState({
      savedEmail: state => state.auth.email,
      status: state => state.auth.status
    }),
    loading () {
      if (this.status === 'requesting code' ||
          this.status === 'logging in') {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    nextStep () {
      this.step++
      // Clear any possible previous erors.
      this.errorMsg = ''
    },
    requestCode () {
      this.$store.dispatch(AUTH_CODE_REQUEST, this.email)
        .then(() => {
          this.nextStep()
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response)
            this.errorMsg = error.response.data
          } else {
            console.log(error)
            this.errorMsg = error
          }
        })
    },
    login () {
      this.$store.dispatch(AUTH_LOGIN_REQUEST, this.accessCode)
        .then(() => {
          console.log('login success')
          this.$router.push({ name: 'home' })
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response)
            this.errorMsg = error.response.data
          } else {
            console.log(error)
            this.errorMsg = error
          }
        })
    }
  },
  mounted () {
    // Data is initialised before computed getters.
    this.email = this.savedEmail
  }
}
</script>
